<template>
	<div>
		<div class="TopSearch">
			<FromComm :FromArr="FromArr" @selectChange="topSelectChange"></FromComm>
			<div class="btngroup">
				<CommonBtngroup ref="btngroup" :qhide="false" @select="getData" @reset="handReset"></CommonBtngroup>
			</div>
		</div>
		<div class="ContentView">
			<div class="BottomTable">
				<Commonbtn v-if="qx.add" backgroundColor="#FFF" title="新增" fontSize="14px" @btnclick="add"
					:src="require('@/assets/icon/icon-add.png')">
				</Commonbtn>
				<Commonbtn v-if="qx.add" backgroundColor="#FFF" title="复制" fontSize="14px" @btnclick="update('copy')"
					:src="require('@/assets/icon/icon-copy.png')">
				</Commonbtn>
				<Commonbtn v-if="qx.update" backgroundColor="#FFF" title="修改" fontSize="14px" :optional="!tableCurr" :useAutoOptional="false" @btnclick="update"
					:src="require('@/assets/icon/icon-update.png')">
				</Commonbtn>
				<Commonbtn v-if="qx.del" backgroundColor="#FFF" title="删除" fontSize="14px" @btnclick="del"
					:src="require('@/assets/icon/icon-del.png')">
				</Commonbtn>
				<Commonbtn v-if="qx.setting" backgroundColor="#FFF" title="分配范围" fontSize="14px"
					@btnclick="handAllocShow" :src="require('@/assets/channel/zhengzhao.png')">
				</Commonbtn>
				<Commonbtn v-if="qx.enabled" backgroundColor="#FFF" title="启用" fontSize="14px" @btnclick="Active"
					:src="require('@/assets/icon/qy.png')">
				</Commonbtn>
				<!--   -->
				<Commonbtn v-if="qx.enabled" backgroundColor="#FFF" title="停用" fontSize="14px" @btnclick="DeActive"
					:src="require('@/assets/icon/icon-stop.png')">
				</Commonbtn>
				<CommonbtnUpLoad v-if="qx.add&&tableCurr" backgroundColor="#FFF" title="覆盖导入" fontSize="14px"
					@getFile="AllImport($event,1)" :src="require('@/assets/icon/icon-drjys.png')"></CommonbtnUpLoad>
				<CommonbtnUpLoad v-if="qx.add&&tableCurr" backgroundColor="#FFF" title="增量导入" fontSize="14px"
					@getFile="AllImport($event,0)" :src="require('@/assets/icon/icon-drjys.png')"></CommonbtnUpLoad>
				<Commonbtn v-if="qx.submit&&tableCurr" backgroundColor="#FFF" title="计算" fontSize="14px"
					@btnclick="handCalcul">
				</Commonbtn>
				<a class="Dowload" style @click="tempDowload">导入模板下载</a>
			</div>
			<div class="custom-table">
				<el-table ref="singleTable" highlight-current-row :data="tableData" style="width: 100%;"
					height="calc(100vh - 230px)" row-key="CSMID" lazy :load="loadNode"
					:tree-props="{children: 'ChildsList', hasChildren: 'hasChildren'}" @current-change="onRowClick">
					<el-table-column prop="CostName" label="类型名称" width="280px" />
					<el-table-column prop="Remark" label="类型备注" />
					<el-table-column prop="NodeTypeName" label="节点类型" width="100px" />
					<el-table-column label="是否适用于IMS" width="130px">
						<template slot-scope="scope">
							{{scope.row.IsSuitIMSByCus?'是':'否'}}
						</template>
					</el-table-column>
					<el-table-column prop="StatusName" label="状态" width="80px" />
					<el-table-column prop="CostTypeName" label="价格形式" width="100px" />
					<el-table-column prop="LEVEL3" label="LEVEL3" width="120px">
						<template slot-scope="scope">
							<el-popover placement="top" title="LEVEL3详情" width="300" trigger="hover">
								<div style="max-height: 300px; overflow-y: auto; white-space: pre-wrap; word-break: break-all;">
									{{ scope.row.LEVEL3 }}
								</div>
								<div slot="reference" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; width: 100%;">
									{{ scope.row.LEVEL3 }}
								</div>
							</el-popover>
						</template>
					</el-table-column>
					<el-table-column prop="PriorityLevel" label="优先级" width="80px" />
					<el-table-column prop="RelationType" label="功能范围" show-overflow-tooltip width="80px" />
					<el-table-column prop="OOrganization" label="出库方" width="100px" />
					<el-table-column prop="SalesModel" label="销售模式" show-overflow-tooltip width="100px" />
				</el-table>
			</div>
		</div>
		<DialogFrom width="1060px" :title="`${CopyID?'复制':tableCurr?'修改':'新增'}价格类型`" :OKASCAN="true"
			:dialogVisible="dialogShow" @cancel="cancelEditor" @dialogOK="dialogOKEditor">
			<FromComm :FromArr="FromArrEditor" @selectChange="selectChange"></FromComm>
			<div class="form-header">
				<div class="header-title">
					产品范围
				</div>
				<div>
					<a class="Dowload" @click="DetailTemplet">导入模版下载</a>
					<CommonbtnUpLoad style="display: inline-block;margin-top: 10px;" backgroundColor="#FFF" title="导入"
						fontSize="14px" @getFile="getFileData" types="file"
						:src="require('@/assets/icon/icon-drjys.png')">
					</CommonbtnUpLoad>
					<Commonbtn backgroundColor="#FFF" title="新增" fontSize="14px" @btnclick="dialogRangeShow = true"
						:src="require('@/assets/icon/icon-add.png')">
					</Commonbtn>
				</div>
			</div>
			<div class="from-table">
				<el-table :data="rangeData" style="width: 100%;" height="400px">
					<el-table-column prop="leveL3" label="L3" show-overflow-tooltip />
					<el-table-column prop="leveL4" label="L4" show-overflow-tooltip />
					<el-table-column prop="costRate" v-if="FromArrEditor.length&&FromArrEditor[4].modelvalue==1"
						label="换算率">
						<template slot-scope="scope">
							<el-input class="table-input" v-model="scope.row.costRate" placeholder="换算率"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="costPrice" v-else-if="FromArrEditor.length&&FromArrEditor[4].modelvalue==2"
						label="服务费">
						<template slot-scope="scope">
							<el-input class="table-input" v-model="scope.row.costPrice" placeholder="服务费"></el-input>
						</template>
					</el-table-column>
					<el-table-column prop="costPrice" label="手工维护价格" v-else>
						<template slot-scope="scope">
							<el-input class="table-input" v-model="scope.row.costPrice" placeholder="手工维护价格"></el-input>
						</template>
					</el-table-column>
					<el-table-column width="80">
						<template slot-scope="scope">
							<i class="el-icon-delete" style="color:red;cursor: pointer;"
								@click="delRange(scope.$index)"></i>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</DialogFrom>

		<DialogFrom width="520px" title="新增产品范围" :OKASCAN="true" :dialogVisible="dialogRangeShow" @cancel="cancelRange"
			@dialogOK="dialogOKRange">
			<el-cascader popper-class="cascader-range" class="selecter" style="width:100%;" filterable clearable v-model="rangeValue" :options="rangeList"
				:props="{ checkStrictly: true }"></el-cascader>
		</DialogFrom>

		<DialogFrom width="1450px" :title="`分配范围-${fwTitle}`" rigthText="添加" :OKASCAN="true" :dialogVisible="allocShow"
			@cancel="cancelAlloc" @dialogOK="dialogOKAlloc">
			<div class="alloc-view">
				<div class="view-flex">
					<div class="v-title">
						已分配范围
					</div>
					<div class="v-switch-center">
						<div class="v-switch">
							<div class="v-switch-item" :class="[currAlloc===index?'v-current':'']"
								v-for="(item,index) in allocList" :key="index" @click="handAlloc(index)">
								{{item}}
							</div>
						</div>
						<FromComm :FromArr="FromLeftForm" />
						<CommonBtngroup class="cus-btn" ref="btngroup" style="top:40px;" :qhide="false"
							@select="GetAllocLeftList" @reset="ResetLeft" />
					</div>
					<div class="v-switch-center" style="padding: 0px 0px 17px;">
						<button class="red-btn" style="margin-left: 0px;" @click="delMoreData">
							批量删除
						</button>
						<button class="red-btn" @click="delAllData">
							全部清空
						</button>
						<button class="red-btn" @click="dateChange('start')">
							变更起始日期
						</button>
						<button class="red-btn" @click="dateChange('end')">
							变更终止日期
						</button>
					</div>
					<div class="v-table">
						<el-table :data="tableAlloc1" @selection-change="handLeftSelection">
							<el-table-column type="selection" width="50" fixed="left" />
							<el-table-column :prop="!currAlloc?'CusCode':'HPCode'" label="编码" width="80" />
							<el-table-column :prop="!currAlloc?'CusName':'HPName'" width="150" show-overflow-tooltip
								:label="`${!currAlloc?'经销商':'医院'}名称`" />
							<el-table-column :prop="!currAlloc?'CustomerProvince':'Province'" show-overflow-tooltip
								:label="!currAlloc?'经营省份':'省'" :width="!currAlloc?100:70" />
							<el-table-column v-if="currAlloc" prop="City" show-overflow-tooltip label="市" width="70" />
							<el-table-column v-if="currAlloc" prop="District" show-overflow-tooltip label="区"
								width="70" />
							<el-table-column label="启效日期" width="110">
								<template slot-scope="scope">
									{{scope.row.StartDate?scope.row.StartDate.substring(0,10):''}}
								</template>
							</el-table-column>
							<el-table-column label="有效期至" width="110">
								<template slot-scope="scope">
									{{scope.row.EndDate?scope.row.EndDate.substring(0,10):''}}
								</template>
							</el-table-column>
							<el-table-column label="操作" width="60" fixed="right">
								<template slot-scope="scope">
									<el-button type="text" style="color:#E71D43;padding:0px;"
										@click="handDelAlloc(scope.row)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div class="pagination">
						<Pagination ref="invPagination" style="transform: scale(0.9);" type='allColor'
							:pageSize="queryAlloc.pageSize" @handleCurrentChange="handleCurrentChange"
							@handleSizeChange="handleSizeChange" :total="total">
						</Pagination>
					</div>
				</div>
				<!-- <div class="view-flex" style="width:24px;flex: none;"></div> -->
				<div class="view-flex">
					<div class="v-title">
						新增范围
					</div>
					<FromComm :FromArr="FromArrForm" @selectChange="handChange" />
					<CommonBtngroup :class="[!currAlloc?'cus-btn':'form-btn']" ref="btngroup" :qhide="false"
						@select="GetAllocRightList" @reset="ResetAlloc" />
					<div class="v-table" style="padding-top: 24px;">
						<el-table :data="tableAlloc2" @selection-change="handSelection" height="480px">
							<el-table-column type="selection" width="50" />
							<el-table-column prop="code6" label="类型" width="65">
								<template slot-scope="scope">
									{{allocList[currAlloc]}}
								</template>
							</el-table-column>
							<el-table-column :prop="!currAlloc?'CusCode':'HPCode'" label="编码" width="90" />
							<el-table-column :prop="!currAlloc?'CusName':'HPName'" show-overflow-tooltip
								:label="`${!currAlloc?'经销商':'医院'}名称`" />
							<el-table-column :prop="!currAlloc?'CustomerProvince':'Province'" show-overflow-tooltip
								:label="!currAlloc?'经营省份':'省'" :width="!currAlloc?100:70" />
							<el-table-column v-if="currAlloc" prop="City" show-overflow-tooltip label="市" width="70" />
							<el-table-column v-if="currAlloc" prop="District" show-overflow-tooltip label="区"
								width="70" />
						</el-table>
					</div>
				</div>
			</div>
		</DialogFrom>

		<DialogFrom width="520px" :title="dateType === 'start' ? '变更起始日期' : '变更终止日期'" :OKASCAN="true" :dialogVisible="dialogDateShow"
			@cancel="dialogDateShow = false" @dialogOK="dialogOKDate">
			<FromComm :FromArr="FromDateForm" />
		</DialogFrom>
	</div>
</template>

<script>
	import FromComm from '../../views/home/components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Commonbtn from '../../../components/common-btn.vue'
	import CommonbtnUpLoad from '../../../components/common-upload.vue'
	import DialogFrom from '../../../components/dialog-from.vue'
	import Pagination from '../../../components/pagination.vue'

	import FromArr from './FormData/FromArr'
	import FromArrEditor from './FormData/FromArrEditor'
	import FromArrCus from './FormData/FromArrCus' //经销商
	import FromArrForm from './FormData/FromArrForm' //医院
	import FromLeftEditor from './FormData/FromLeftEditor' //医院

	import DateFormCus from './FormData/FromDateForm' //效期变更

	import {
		GetHelperCostType,
		GetCostSettingListByTree,
		GetCostSettingListParent,
		GetHelperNodeType,
		InfoCostSettingData,
		AddCostSettingData,
		EditCostSettingData,
		DeleteCostSettingData,
		GetHelperLEVEL134,
		GetProvince,
		GetCity,
		GetDistrict,
		CostSettingCustomerList,
		CostSettingHospitalList,
		AddCostSettingCustomer,
		RemoveCostSettingCustomer,
		AddCostSettingHospital,
		RemoveCostSettingHospital,
		CostSettingDownloadDetailTemplet,
		CostSettingImportDetail,
		RemoveAllCustomer,
		RemoveAllHospital,
		ActivedCostSetting,
		DisabledCostSetting,
		DownloadRangeSettingTemplet,
		ImportRangeSetting,
		EditCustomerStartDate,
		EditCustomerEndDate,
		EditHospitalStartDate,
		EditHospitalEndDate,
		GetFirstOrganization,
		GetSalesModelForCostSetting,
		SetCostSettingByCSMID,
		GetHelperLevel1,
		GetLevel3List
	} from '@/api/newsapi'

	import {
		InventoryClassList,
	} from '@/api/home'

	export default {
		components: {
			FromComm,
			CommonBtngroup,
			Commonbtn,
			DialogFrom,
			Pagination,
			CommonbtnUpLoad
		},
		data() {
			return {
				dateType: 'start',
				dialogDateShow: false,
				dialogShow: false,
				dialogRangeShow: false,
				FromArr: [],
				FromDateForm: [],
				FromLeftForm: [],
				FromArrEditor: [],
				FromArrForm: [],
				tableCurr: null,
				tableData: [],
				rangeValue: [],
				rangeList: [],
				rangeData: [],
				//范围
				allocList: ['经销商', '医院'],
				allocShow: false,
				currAlloc: 0,
				queryAlloc: {
					pageIndex: 1,
					pageSize: 10,
				},
				total: 0,
				tableAlloc1: [],
				tableAlloc2: [],
				selectionIds: [],
				qus: [],
				currentType: null,
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: false,
					daoc: false,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					setting: false
				},
				fwTitle: '',
				selectionLeftIds: [],
				CopyID: ''
			}
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.FromLeftForm = JSON.parse(JSON.stringify(FromLeftEditor));
			this.FromArrEditor = JSON.parse(JSON.stringify(FromArrEditor))
			this.FromArrForm = JSON.parse(JSON.stringify(FromArrCus))
			this.FromDateForm = JSON.parse(JSON.stringify(DateFormCus))
			this.QX();
			this.GetHelperCostType();
			this.GetCostSettingListParent();
			this.GetHelperNodeType();
			this.GetHelperLEVEL134();
			this.getData();
			this.GetFirstOrganization();
			this.getHelperLevel1();
		},
		methods: {
			//获取l1数据
			async getHelperLevel1() {
				let {
					code,
					data
				} = await GetHelperLevel1({});
				if (code == 0) {
					this.FromArr[2].options = []
					data.map((item, index) => {
						this.FromArr[2].options.push({
							key: item.value,
							value: item.key
						})
					})
				}
			},
			topSelectChange(i) {
				if (i === 2) {
					this.getLevel3Data(this.FromArr[2].modelvalue);
					this.FromArr[3].modelvalue = '';
				}
			},
			async getLevel3Data(level1) {
				if (!level1) {
					this.FromArr[3].options = [];
					return;
				}
				let {
					code,
					data
				} = await GetLevel3List({
					LEVEL1: level1
				});
				if (code == 0) {
					this.FromArr[3].options = [];
					data.map((item, index) => {
						this.FromArr[3].options.push({
							key: item.Value,
							value: item.Text
						})
					})
				}
			},
			//计算
			async handCalcul() {
				if (!this.tableCurr) {
					this.$message.error('请选择一条数据');
					return;
				}
				const loading = this.$loading({
					lock: true,
					text: '计算中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					code,
					message
				} = await SetCostSettingByCSMID({
					CSMID: this.tableCurr
				});
				loading.close();
				if (code == 0) {
					this.getData()
					this.$message.success('操作成功！');
				} else {
					this.$message.error(message);
				}
			},
			dateChange(type) {
				if (!this.selectionLeftIds.length) {
					this.$message.error('请勾选数据');
					return;
				}
				this.dateType = type;
				this.FromDateForm = JSON.parse(JSON.stringify(DateFormCus));
				
				if (type === 'start') {
					this.FromDateForm = [this.FromDateForm[0]]; // 只保留起始日期
					this.FromDateForm[0].title = "变更起始日期：";
				} else {
					this.FromDateForm = [this.FromDateForm[1]]; // 只保留终止日期
					this.FromDateForm[0].title = "变更终止日期：";
				}

				const firstItem = this.selectionLeftIds[0];
				if (type === 'start' && firstItem.StartDate) {
					this.FromDateForm[0].modelvalue = firstItem.StartDate.substring(0, 10);
				}
				if (type === 'end' && firstItem.EndDate) {
					this.FromDateForm[0].modelvalue = firstItem.EndDate.substring(0, 10);
				}
				this.dialogDateShow = true;
			},
			async dialogOKDate() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let res = null;
				if (this.dateType === 'start') {
					if (!this.currAlloc) {
						res = await EditCustomerStartDate({
							CSMID: this.tableCurr,
							lstIDs: this.selectionLeftIds.map(item => item.CSID),
							StartDate: this.FromDateForm[0].modelvalue
						});
					} else {
						res = await EditHospitalStartDate({
							CSMID: this.tableCurr,
							lstIDs: this.selectionLeftIds.map(item => item.CSID),
							StartDate: this.FromDateForm[0].modelvalue
						});
					}
				} else {
					if (!this.currAlloc) {
						res = await EditCustomerEndDate({
							CSMID: this.tableCurr,
							lstIDs: this.selectionLeftIds.map(item => item.CSID),
							EndDate: this.FromDateForm[0].modelvalue
						});
					} else {
						res = await EditHospitalEndDate({
							CSMID: this.tableCurr,
							lstIDs: this.selectionLeftIds.map(item => item.CSID),
							EndDate: this.FromDateForm[0].modelvalue
						});
					}
				}
				
				loading.close();
				if (res.code == 0) {
					this.dialogDateShow = false;
					this.$message.success('变更成功');
					this.GetAllocLeftList();
					this.GetAllocRightList();
				} else {
					this.$message.error(res.message);
				}
			},
			//导入模板下载
			async tempDowload() {
				let {
					data,
					code,
					message
				} = await DownloadRangeSettingTemplet({});
				if (code == 0) {
					window.location.href = data;
				} else {
					this.$message.error(message);
				}
			},
			// 完全/增量导入
			async AllImport(file, type) {
				const loading = this.$loading({
					lock: true,
					text: '正在导入...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formdata = new FormData()
				formdata.append('file', file)
				let {
					data,
					code,
					message
				} = await ImportRangeSetting(formdata, this.tableCurr, type)
				if (code == 0) {
					this.$message.success('导入成功');
					this.getData();
				} else {
					if (data && data.length) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message.error(message);
					}
				}
				loading.close();
			},
			//启用
			async Active() {
				if (!this.tableCurr) {
					this.$message.warning('请选择您要操作的数据')
					return
				}
				const loading = this.$loading({
					lock: true,
					text: "启用中...",
					spinner: "el-icon-loading",
					background: "rgba(255,255,255,0.3)"
				});
				let {
					code,
					data,
					messgae
				} = await ActivedCostSetting({
					CSMID: this.tableCurr
				})
				loading.close();
				if (code == 0) {
					this.getData()
					this.$message.success('启用成功！');
				} else {
					this.$message.error(messgae);
				}
			},
			//禁用
			async DeActive() {
				if (!this.tableCurr) {
					this.$message.warning('请选择您要操作的数据')
					return
				}
				const loading = this.$loading({
					lock: true,
					text: "禁用中...",
					spinner: "el-icon-loading",
					background: "rgba(255,255,255,0.3)"
				});
				let {
					code,
					data
				} = await DisabledCostSetting({
					CSMID: this.tableCurr
				})
				loading.close();
				if (code == 0) {
					this.getData()
					this.$message.success('禁用成功！');
				} else {
					this.$message.error(messgae);
				}
			},
			//查询列表树数据
			async getData() {
				// const loading = this.$loading({
				// 	lock: true,
				// 	text: "加载中...",
				// 	spinner: "el-icon-loading",
				// 	background: "rgba(255,255,255,0.3)"
				// });
				let {
					code,
					data
				} = await GetCostSettingListByTree({
					costName: this.FromArr[0].modelvalue,
					costType: this.FromArr[1].modelvalue,
					level1: this.FromArr[2].modelvalue,
					level3: this.FromArr[3].modelvalue,
					Customer: this.FromArr[4].modelvalue,
					Hospital: this.FromArr[5].modelvalue,
					Grade: 1
				})
				//loading.close();
				if (code == 0) {
					this.tableData = data.map(item => {
						item.hasChildren = item.IsEnd === 0;
						return item;
					});
					this.currentType = null;
				}
			},
			// 懒加载子节点
			async loadNode(tree, treeNode, resolve) {
				let {
					code,
					data
				} = await GetCostSettingListByTree({
					costName: this.FromArr[0].modelvalue,
					costType: this.FromArr[1].modelvalue,
					level1: this.FromArr[2].modelvalue,
					level3: this.FromArr[3].modelvalue,
					Customer: this.FromArr[4].modelvalue,
					Hospital: this.FromArr[5].modelvalue,
					ParentID: tree.CSMID
				})
				if (code == 0) {
					const children = data.map(item => {
						item.hasChildren = item.IsEnd === 0;
						return item;
					});
					resolve(children);
				} else {
					resolve([]);
				}
			},
			//重置
			handReset() {
				this.FromArr.map((item, index) => {
					item.modelvalue = '';
					return item;
				})
				this.getData();
			},
			// 产品线
			async GetInvClass() {
				let {
					code,
					data
				} = await InventoryClassList({})
				if (code == 0) {
					this.FromArrForm[0].options = []
					data.data.map((item, index) => {
						this.FromArrForm[0].options.push({
							key: item.InvClass,
							value: item.InvClassName
						})
					})
				}
			},
			// 价格形式下拉框
			async GetHelperCostType() {
				let {
					code,
					data
				} = await GetHelperCostType({})
				if (code == 0) {
					this.FromArr[1].options = []
					this.FromArrEditor[4].options = []
					data.map((item, index) => {
						this.FromArr[1].options.push({
							key: item.Value,
							value: item.Text
						})
						this.FromArrEditor[4].options.push({
							label: item.Text,
							value: item.Value,
						})
					})
				}
			},
			// 上级类型
			async GetCostSettingListParent() {
				let {
					code,
					data,
					message
				} = await GetCostSettingListParent({});
				if (code == 0) {
					this.FromArrEditor[0].options = data;
				}
			},
			// 节点类型下拉框
			async GetHelperNodeType() {
				let {
					code,
					data,
					message
				} = await GetHelperNodeType({});
				if (code == 0) {
					this.FromArrEditor[1].options = []
					data.map((item, index) => {
						this.FromArrEditor[1].options.push({
							key: item.Value,
							value: item.Text
						})
					})
				}
			},
			//出库方选择
			selectChange(i) {
				if (i === 7) {
					this.GetSalesModelForCostSetting(this.FromArrEditor[i].modelvalue);
				}
			},
			// 出库方
			async GetFirstOrganization() {
				let {
					code,
					data,
					message
				} = await GetFirstOrganization({});
				if (code == 0) {
					this.FromArrEditor[7].options = []
					data.map((item, index) => {
						this.FromArrEditor[7].options.push({
							key: item.Value,
							value: item.Text,
						})
					})
				}
			},
			// 销售模式
			async GetSalesModelForCostSetting(e) {
				let {
					code,
					data,
					message
				} = await GetSalesModelForCostSetting({
					CompanyID: e
				});
				if (code == 0) {
					this.FromArrEditor[8].hidden = data.length ? false : true;
					this.FromArrEditor[8].modelvalue = '';
					this.FromArrEditor[8].options = [];
					data.map((item, index) => {
						this.FromArrEditor[8].options.push({
							key: item.Value,
							value: item.Text,
						})
					})
				}
			},
			// 新增产品范围
			async GetHelperLEVEL134() {
				let {
					code,
					data,
					message
				} = await GetHelperLEVEL134({});
				if (code == 0) {
					let childrenList = [];
					data.map(item => {
						childrenList.push({
							label: item.LEVEL1,
							value: item.LEVEL1,
							children: item.LEVEL3s.map(item1 => {
								return {
									label: item1.LEVEL3,
									value: item1.LEVEL3,
									children: item1.LEVEL4s.length && item1.LEVEL4s[0] != "" ?
										item1.LEVEL4s.map(item2 => {
											return {
												label: item2,
												value: item2,
											}
										}) : []
								}
							})
						})
					});
					this.rangeList = childrenList;
				}
			},
			handChange(e) {
				if (this.currAlloc) { //此操作只在医院生效
					if (e === 0) {
						this.FromArrForm[1].modelvalue = '';
						this.FromArrForm[2].modelvalue = '';
						this.GetCity();
					}
					if (e === 1 && this.FromArrForm[0].modelvalue) {
						this.FromArrForm[2].modelvalue = '';
						this.GetDistrict();
					}
				}
			},
			//查询省份数据
			async GetProvince(key = 1) {
				let {
					code,
					data,
					message
				} = await GetProvince({});
				if (code == 0) {
					this.FromArrForm[key].options = []
					data.map((item, index) => {
						this.FromArrForm[key].options.push({
							key: item.Value,
							value: item.Text
						})
					})
				}
			},
			//查询城市数据
			async GetCity() {
				let {
					code,
					data,
					message
				} = await GetCity({
					params: {
						ProvinceID: this.FromArrForm[0].modelvalue
					}
				});
				if (code == 0) {
					this.FromArrForm[1].options = []
					data.map((item, index) => {
						this.FromArrForm[1].options.push({
							key: item.Value,
							value: item.Text
						})
					})
				}
			},
			//查询地区数据
			async GetDistrict() {
				let {
					code,
					data,
					message
				} = await GetDistrict({
					params: {
						CityID: this.FromArrForm[1].modelvalue
					}
				});
				if (code == 0) {
					this.FromArrForm[2].options = []
					data.map((item, index) => {
						this.FromArrForm[2].options.push({
							key: item.Value,
							value: item.Text
						})
					})
				}
			},
			handleCurrentChange(e) {
				this.queryAlloc.pageIndex = e
				this.GetAllocLeftList()
			},
			handleSizeChange(e) {
				this.queryAlloc.pageSize = e
				this.GetAllocLeftList()
			},
			//打开分配范围
			handAllocShow() {
				if (!this.tableCurr) {
					this.$message.warning('请选择您要操作的数据')
					return
				}

				if (this.currentType === 0) {
					this.$message.error('目录不可分配范围！')
					return;
				}
				this.currAlloc = 0;
				this.queryAlloc.pageIndex = 1;
				this.allocShow = true;
				this.GetInvClass();
				this.GetProvince();
				this.GetAllocLeftList();
				this.GetAllocRightList();
			},
			//切换经销商/医院
			handAlloc(i) {
				this.currAlloc = i;
				this.queryAlloc.pageIndex = 1;
				this.GetAllocLeftList();
				this.GetAllocRightList();
				this.SetViewData();
			},
			//表格勾选
			handLeftSelection(val) {
				this.selectionLeftIds = val;
			},
			//表格勾选
			handSelection(val) {
				this.selectionIds = val;
			},
			//查询左侧 经销商/医院
			async GetAllocLeftList() {
				let res = null;
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				this.queryAlloc.CSMID = this.tableCurr;
				this.queryAlloc.IsRelation = 1; //已分配传1 否则 0
				if (!this.currAlloc) {
					this.queryAlloc.CusName = this.FromLeftForm[0].modelvalue;
					res = await CostSettingCustomerList(this.queryAlloc);
				} else {
					this.queryAlloc.HosType = '医院';
					this.queryAlloc.HPName = this.FromLeftForm[0].modelvalue;
					res = await CostSettingHospitalList(this.queryAlloc);
				}
				loading.close();
				if (res.code == 0) {
					this.tableAlloc1 = res.data.data;
					this.total = res.data.Count;
				} else {
					this.$message.error(res.message);
				}
			},
			//查询右侧 经销商/医院
			async GetAllocRightList() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let params = {
						PageSize: 50
					},
					res = null;
				this.FromArrForm.map(item => {
					params[item.key] = item.modelvalue;
				})
				params.CSMID = this.tableCurr;
				params.IsRelation = 0; //已分配传1 否则 0
				if (!this.currAlloc) {
					params.CusName = params.Name;
					delete params.Name;
					res = await CostSettingCustomerList(params);
				} else {
					params.HPName = params.Name;
					params.HosType = '医院';
					delete params.Name;
					res = await CostSettingHospitalList(params);
				}
				loading.close();
				if (res.code == 0) {
					this.tableAlloc2 = res.data.data;
				} else {
					this.$message.error(res.message);
				}
			},
			ResetAlloc() {
				this.FromArrForm.map(item => {
					item.modelvalue = '';
					return item;
				})
				this.GetAllocRightList();
			},
			ResetLeft() {
				this.FromLeftForm.map(item => {
					item.modelvalue = '';
					return item;
				})
				this.GetAllocLeftList();
			},
			cancelAlloc() {
				this.allocShow = false;
			},
			//添加 经销商/医院
			async dialogOKAlloc() {
				if (!this.selectionIds.length) {
					this.$message.warning('请选择您要操作的数据')
					return
				}
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let res = null,
					arr = [];
				if (!this.currAlloc) {
					this.selectionIds.map(item => {
						arr.push({
							CusCode: item.CusCode,
							isProvince: item.IsProvince,
							StartDate: item.StartDate,
							EndDate: item.EndDate
						})
					})
					res = await AddCostSettingCustomer({
						StartDate: this.FromArrForm[3].modelvalue,
						EndDate: this.FromArrForm[4].modelvalue,
						inputs: arr
					}, this.tableCurr);
				} else {
					this.selectionIds.map(item => {
						arr.push({
							hpid: item.HPID,
							isProvince: item.IsProvince,
							StartDate: item.StartDate,
							EndDate: item.EndDate
						})
					})
					res = await AddCostSettingHospital({
						StartDate: this.FromArrForm[4].modelvalue,
						EndDate: this.FromArrForm[5].modelvalue,
						inputs: arr
					}, this.tableCurr);
				}
				loading.close();
				if (res.code == 0) {
					this.$message.success('添加成功');
					this.selectionIds = [];
					this.queryAlloc.pageIndex = 1;
					this.GetAllocLeftList();
					this.GetAllocRightList();
				} else {
					this.$message.error(res.message);
				}
			},
			//删除经销商/医院
			handDelAlloc(row) {
				this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					const loading = this.$loading({
						lock: true,
						text: '加载中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let res = null;
					if (!this.currAlloc) {
						res = await RemoveCostSettingCustomer({
							csid: row.CSID
						});
					} else {
						res = await RemoveCostSettingHospital({
							csid: row.CSID
						});
					}
					loading.close();
					if (res.code == 0) {
						this.$message.success('删除成功');
						this.GetAllocLeftList();
						this.GetAllocRightList();
					} else {
						this.$message.error(res.message);
					}
				}).catch(() => {});
			},
			add() {
				this.$refs.singleTable.setCurrentRow('');
				this.tableCurr = null;
				this.dialogShow = true;
			},
			// 指标删除
			del() {
				if (!this.tableCurr) {
					this.$message.warning('请选择您要操作的数据')
					return
				}
				this.$confirm('是否删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					const loading = this.$loading({
						lock: true,
						text: '加载中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let {
						code,
						data,
						message
					} = await DeleteCostSettingData({
						csmid: this.tableCurr
					})
					if (code == 0) {
						this.tableCurr = null;
						this.$message.success('已删除');
						this.getData();
						this.dialogVisibleDel = false;
					} else {
						this.$message.error(message);
					}
					loading.close();
				}).catch(() => {});
			},
			onRowClick(val) {
				if (val) {
					this.tableCurr = val.CSMID;
					this.currentType = val.NodeType;
					this.fwTitle = val.CostName;
				}
			},
			//编辑
			async update(t = '') {
				if (!this.tableCurr) {
					this.$message.error('请先选择数据');
					return;
				}
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				//复制流程
				if (t) {
					this.CopyID = this.tableCurr;
				}
				let {
					code,
					data
				} = await InfoCostSettingData({
					csmid: this.tableCurr
				})
				if (code == 0) {
					this.$set(this.FromArrEditor[0], 'modelvalue', data.ParentID);
					this.$set(this.FromArrEditor[1], 'modelvalue', data.NodeType);
					this.$set(this.FromArrEditor[2], 'modelvalue', data.CostName);
					this.$set(this.FromArrEditor[3], 'modelvalue', data.Remark);
					this.$set(this.FromArrEditor[4], 'modelvalue', data.CostType === null ? 0 : data.CostType);
					this.$set(this.FromArrEditor[5], 'modelValue', data.PriorityLevel ? data.PriorityLevel : 0);
					this.$set(this.FromArrEditor[6], 'checked', data.IsSuitIMSByCus ? true : false);
					this.$set(this.FromArrEditor[7], 'modelvalue', data.OOrganization);
					this.$set(this.FromArrEditor[8], 'modelvalue', data.SalesModel);
					this.$set(this.FromArrEditor[8], 'hidden', data.SalesModel ? false : true);
					if (data.SalesModel) {
						this.GetSalesModelForCostSetting(data.OOrganization);
					}

					if (data.DetailsInput && data.DetailsInput.length) {
						data.DetailsInput.forEach(item => {
							this.rangeData.push({
								level1: item.LEVEL1,
								leveL3: item.LEVEL3,
								leveL4: item.LEVEL4,
								costRate: item.CostRate,
								costPrice: item.CostPrice,
							})
						})
					}
					this.dialogShow = true;
					this.$forceUpdate();
				}
				loading.close();
			},
			//取消编辑
			cancelEditor() {
				this.FromArrEditor = this.FromArrEditor.map(item => {
					item.modelValue = 0;
					item.modelvalue = '';
					if (item.key === 'costType') {
						item.modelvalue = 0;
					}
					return item;
				})
				this.tableCurr = null;
				this.rangeData = [];
				this.dialogShow = false;
				this.CopyID = '';
				this.$refs.singleTable.setCurrentRow('');
				this.$forceUpdate();
			},
			async dialogOKEditor() {
				let params = {};
				this.FromArrEditor.map(item => {
					params[item.key] = item.modelvalue;
					if (item.key === 'parentID') {
						if (Array.isArray(item.modelvalue)) {
							params.parentID = item.modelvalue && item.modelvalue.length ? item.modelvalue
								.length >
								1 ? item.modelvalue[item.modelvalue.length - 1] : item.modelvalue[0] : ''
						} else {
							params.parentID = item.modelvalue;
						}
					}
					if (item.key === 'priorityLevel') {
						params.priorityLevel = item.modelValue;
					}
					if (item.key === 'IsSuitIMSByCus') {
						params.IsSuitIMSByCus = item.checked ? 1 : 0;
					}
				})
				if (this.rangeData.length) {
					let list = this.rangeData,
						msg = '';
					for (var i = 0; i < list.length; i++) {
						if (params.costType === 0 && !String(list[i].costPrice)) {
							msg = `${list[i].leveL3}的手工维护价格未填写！`;
							break;
						}
						if (params.costType === 1 && !String(list[i].costRate)) {
							msg = `${list[i].leveL3}的换算率未填写！`;
							break;
						}
					}
					if (msg) {
						this.$message.error(msg);
						return item;
					}
					params.detailsInput = this.rangeData;
				}
				this.FromArr[0].modelvalue = this.FromArrEditor[2].modelvalue;
				this.$forceUpdate();
				if (this.tableCurr) {
					if (this.CopyID) {
						params.CopyID = this.CopyID;
						//复制
						this.addModel(params);
					} else {
						//修改
						const loading = this.$loading({
							lock: true,
							text: '加载中...',
							spinner: 'el-icon-loading',
							background: 'rgba(255,255,255,0.3)'
						});
						params.csmid = this.tableCurr;
						let {
							code,
							data,
							message
						} = await EditCostSettingData(params);
						loading.close();
						if (code == 0) {
							this.tableCurr = null;
							this.$message.success('修改成功');
							this.cancelEditor();
							this.getData();
						} else {
							this.$message.error(message);
						}
					}
				} else {
					//添加
					this.addModel(params);
				}
			},
			///添加
			async addModel(params) {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					data,
					message
				} = await AddCostSettingData(params)
				loading.close();
				if (code == 0) {
					this.$message.success('添加成功');
					this.cancelEditor();
					this.getData();
				} else {
					this.$message.error(message);
				}
			},
			cancelRange() {
				this.dialogRangeShow = false;
				this.rangeValue = [];
			},
			dialogOKRange() {
				let msg = '';
				if (!this.rangeValue.length || this.rangeValue.length < 2) {
					this.$message.error('最少选择两级');
					return;
				}

				for (var i = 0; i < this.rangeData.length; i++) {
					if (this.rangeValue.length === 3) {
						if (this.rangeData[i].leveL3 == this.rangeValue[1] && this.rangeData[i].leveL4 == this.rangeValue[
								2]) {
							msg = '数据重复!';
							break;
						}
					} else {
						if (this.rangeData[i].leveL3 == this.rangeValue[1]) {
							msg = '数据重复!';
							break;
						}
					}
				}
				if (msg) {
					this.$message.error(msg);
					return
				}
				this.rangeData.push({
					leveL1: this.rangeValue[0],
					leveL3: this.rangeValue[1],
					leveL4: this.rangeValue.length === 3 ? this.rangeValue[2] : '',
					costRate: '', //换算率
					costPrice: '', //手工维护价格
				})
			},
			delRange(i) {
				this.rangeData.splice(i, 1);
			},
			QX() {
				let data = JSON.parse(localStorage.getItem("MenusData"))
				data.Menus[0].Nodes.map((item, index) => {
					if (item.NodeID == 159) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 160) {
								this.qus = items.Nodes
							}
						})
					}
					// console.log(this.qus, 'this.qus');
				})
				if (this.qus) {
					this.qus.map((item, index) => {
						if (item.NodeName == 'add') {
							this.qx.add = true
						} else if (item.NodeName == 'edit') {
							this.qx.update = true
						} else if (item.NodeName == 'delete') {
							this.qx.del = true
						} else if (item.NodeName == 'stopif') {
							this.qx.del = true
						} else if (item.NodeName == 'assignment') {
							this.qx.assignment = true
						} else if (item.NodeName == 'enabled') {
							this.qx.enabled = true
						} else if (item.NodeName == 'skip') {
							this.qx.skip = true
						} else if (item.NodeName == 'reset') {
							this.qx.reset = true
						} else if (item.NodeName == 'setting') {
							this.qx.setting = true
						} else if (item.NodeName == 'submit') {
							this.qx.submit = true
						}
					})
				}
			},
			//切换经销商医院时 对界面上  的一些操作
			SetViewData() {
				this.FromArrForm = JSON.parse(JSON.stringify(!this.currAlloc ? FromArrCus : FromArrForm));
				if (!this.currAlloc) {
					this.GetInvClass();
					this.GetProvince();
				} else {
					this.GetProvince(0);
				}
			},
			// 下载模板
			async DetailTemplet() {
				// 测试
				let {
					data,
					code,
					message
				} = await CostSettingDownloadDetailTemplet({})
				if (code == 0) {
					window.location.href = data
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			getFileData(e) {
				this.$confirm('导入会清掉已填写明细,是否确认?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					this.uploadFile(e);
				}).catch(() => {});
			},
			async uploadFile(e) {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let formData = new FormData();
				formData.append('CostType', this.FromArrEditor[4].modelvalue);
				formData.append('file', e);
				let {
					code,
					data,
					message
				} = await CostSettingImportDetail(formData);
				loading.close();
				if (code == 0) {
					if (data.length) {
						this.rangeData = [];
						data.forEach(item => {
							this.rangeData.push({
								leveL1: item.LEVEL1,
								leveL3: item.LEVEL3,
								leveL4: item.LEVEL4,
								costRate: item.CostRate, //换算率
								costPrice: item.CostPrice, //手工维护价格
							})
						})
					}
				} else {
					if (data.length) {
						this.$alert(`${data.join('<br/>')}`, '提示', {
							dangerouslyUseHTMLString: true,
							showConfirmButton: false
						});
					} else {
						this.$message.error(message);
					}
				}
			},
			async delMoreData() {
				if (!this.selectionLeftIds.length) {
					this.$message.error('请勾选数据');
					return;
				}
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let res = null;
				if (!this.currAlloc) {
					res = await RemoveCostSettingCustomer({
						CSIDs: this.selectionLeftIds.map(item => item.CSID)
					});
				} else {
					res = await RemoveCostSettingHospital({
						CSIDs: this.selectionLeftIds.map(item => item.CSID)
					});
				}
				loading.close();
				if (res.code == 0) {
					this.$message.success('删除成功');
					this.GetAllocLeftList();
					this.GetAllocRightList();
				} else {
					this.$message.error(res.message);
				}
			},
			delAllData() {
				this.$confirm('全部清空数据,是否确认?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(async () => {
					const loading = this.$loading({
						lock: true,
						text: '加载中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let res = null;
					if (!this.currAlloc) {
						res = await RemoveAllCustomer({
							csmid: this.tableCurr
						});
					} else {
						res = await RemoveAllHospital({
							csmid: this.tableCurr
						});
					}
					loading.close();
					if (res.code == 0) {
						this.$message.success('删除成功');
						this.GetAllocLeftList();
						this.GetAllocRightList();
					} else {
						this.$message.error(res.message);
					}
				}).catch(() => {});
			}
		}
	}
</script>

<style lang="less" scoped>
	.TopSearch {
		height: 148px;
		margin: 0px 0px 8px;
		background: #FFFFFF;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);

		.btngroup {
			// border: 1px solid #0b65ec;
			position: relative;
			bottom: 20px;
		}
	}

	.ContentView {
		background: #FFFFFF;

		.BottomTable {
			padding: 10px 12px;
		}

		.custom-table {
			padding: 0px 24px 24px 24px;

			/deep/.el-table .el-table__cell {
				padding: 8px 0;
			}

			/deep/.el-table th.el-table__cell {
				background: #F3F3F3;
			}
		}
	}


	.form-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-top: 24px;
		padding: 12px 0px;
		border-top: 1px solid #E5E5E5;

		.header-title {
			font-size: 14px;
			font-family: PingFang SC-Medium, PingFang SC;
			font-weight: 600;
			color: #333333;
		}

		.Dowload {
			display: inline-block;
		}
	}

	.from-table {
		//padding: 0px 24px 24px 24px;

		/deep/.el-table .el-table__cell {
			padding: 8px 0;
		}

		/deep/.el-table th.el-table__cell {
			background: #F3F3F3;
		}

		.table-input {
			/deep/.el-input__inner {
				height: 32px;
				line-height: 32px;
				border: 0px;
			}
		}
	}

	.selecter {

		/deep/.el-input .el-input__inner:focus {
			border-color: #E71D43 !important;
		}

		/deep/.el-input.is-focus .el-input__inner {
			border-color: #E71D43 !important;
		}

		/deep/.el-input__inner {
			height: 32px;
			line-height: 32px;
			border-radius: 0px;
		}
	}

	.alloc-view {
		display: flex;
		align-items: flex-start;
		justify-content: space-around;

		.view-flex {
			flex: 1;
			position: relative;
			max-width: 638px;

			.v-title {
				font-size: 14px;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #333333;
			}

			.cus-btn {
				margin: 0px;
				position: absolute;
				top: 82px;
				right: 0px;
			}

			.form-btn {
				margin: 0px;
				position: absolute;
				top: -12px;
				right: 16px;
			}

			.v-switch-center {
				display: flex;
				padding: 12px 0px;

				.v-switch {
					display: flex;
					align-items: center;
					width: 200px;
					height: 40px;
					background: #F3F3F3;
					border-radius: 4px 4px 4px 4px;
					cursor: pointer;

					.v-switch-item {
						width: 100px;
						height: 32px;
						line-height: 32px;
						border-radius: 2px 2px 2px 2px;
						text-align: center;
						font-size: 14px;
						font-family: PingFang SC-Regular, PingFang SC;
						font-weight: 400;
						color: #E71D43;
					}

					.v-current {
						background: #E71D43;
						color: #FFFFFF;
					}
				}

				.red-btn {
					border: 1px solid #e6e6e6;
					border-radius: 2px;
					text-align: center;
					color: #fff;
					background-color: #e71d43;
					display: inline-block;
					margin-left: 10px;
					cursor: pointer;
					opacity: 1;
					padding: 7px 17px;
				}

				.red-btn:hover {
					background-color: #e03f5d;
				}

				.red-btn:active {
					background-color: #c01837;
				}
			}

			.v-table {
				/deep/.el-table .el-table__cell {
					padding: 8px 0;
				}

				/deep/.el-table th.el-table__cell {
					background: #F3F3F3;
				}

				// /deep/.el-checkbox__input.is-checked .el-checkbox__inner,
				/deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
					background-color: #e71d43;
					border-color: #e71d43;
				}
			}
		}
	}
</style>

<style>
.cascader-range .el-cascader-panel {
	max-height: 400px;
}
</style>
